export function NLPLogo({ className = 'h-12' }: { className?: string }) {
  return (
    <img
      src="/nlp_os_logo copy.png"
      alt="NLP OS - Human Potential"
      className={`${className} w-auto object-contain`}
    />
  );
}


